







































































































































import BaseComponent from '@/core/base.component';
import { Component, Vue, Watch } from 'vue-property-decorator';
import QNAService from '@/services/qna.service';
import { QNADto } from '@/dto/qna';
import { QNAReplyDto, QNAReplyCreateDto } from '../../../dto/qna';
import { Pagination } from '../../../core';
import ReplyChangeDialog from './ReplyChangeDialog.vue';
import store from '@/store';
@Component({
  name: 'QNADetail',
  components: { ReplyChangeDialog },
})
export default class QNADetail extends BaseComponent {
  private QNADto = new QNADto();
  private replyList: QNAReplyDto[] = [];
  private QNAReplyCreateDto = new QNAReplyCreateDto();
  private pagination = new Pagination();
  private changeDialog = false;
  private selectedReply = null;
  private store = store;
  private replyCount = null;
  private replyLoading = false;
  private QNAContentLoading = false;
  private addBtnLoading = false;

  // @Watch('replyList', {
  //   deep: true,
  // })
  // replyListChanged() {
  //   this.scrollToEnd();
  // }
  @Watch('pagination', {
    deep: true,
  })
  paginationChanged() {
    this.getReply();
  }
  getDetail() {
    this.QNAContentLoading = true;
    QNAService.findOne(this.$route.params.id).subscribe(res => {
      this.QNADto = res.data;
      this.QNAContentLoading = false;
    });
  }
  getReply() {
    this.replyLoading = true;
    QNAService.findAllReply(this.$route.params.id, this.pagination).subscribe(
      res => {
        this.replyList = res.data.items.reverse();
        this.replyCount = res.data.totalCount;
        this.replyLoading = false;
      },
    );
  }
  onChangeReplyBtn(reply) {
    this.selectedReply = reply;
    this.changeDialog = !this.changeDialog;
  }
  createReply() {
    this.addBtnLoading = true;
    QNAService.createReply(
      this.$route.params.id,
      this.QNAReplyCreateDto,
    ).subscribe(res => {
      this.addBtnLoading = false;
      this.QNAReplyCreateDto = new QNAReplyCreateDto();
      this.getReply();
    });
  }
  addReply() {
    this.createReply();
    this.scrollToEnd();
  }
  scrollToEnd() {
    this.$nextTick(() => {
      window.scrollTo(0, 99999);
    });
  }
  async init() {
    this.getDetail();
    const res = await this.getReply();
    this.scrollToEnd();
  }
  created() {
    this.init();
  }
}
